import { bootstrapApplication } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { provideRouter, RouterOutlet } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { KeycloakService } from './app/services/keycloak.service';
import { MatPaginatorIntlPtBr } from './app/shared/component/paginator-component/paginator-config';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <div class="app-container">
      <main class="main-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  `
})
class AppComponent { }

async function initApp() {
  const keycloakService = new KeycloakService();

  try {
    await keycloakService.init();

    return bootstrapApplication(AppComponent, {
      providers: [
        provideAnimationsAsync(),
        { provide: MatPaginatorIntl, useClass: MatPaginatorIntlPtBr },
        provideRouter(routes),
        provideHttpClient(withInterceptors([authInterceptor])),
        { provide: KeycloakService, useValue: keycloakService },
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' } 
      ]
    });
  } catch (error) {
    return bootstrapApplication(AppComponent, {
      providers: [
        provideRouter(routes),
        provideHttpClient(withInterceptors([authInterceptor])),
        { provide: KeycloakService, useValue: keycloakService },
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
      ] 
    });
  }
}

initApp().catch(err => console.error('Erro crítico ao inicializar app:', err));


